import { useState, useEffect, useRef } from "react";
import posthog from "../../lib/posthog";
import programmeIllustration from '../../assets/programme-starterscreen.svg';
import manualIllustration from '../../assets/manual-starterscreen.svg';
import DailyNoteCard from "../../components/DailyNoteCard";

import { mealAccents } from "../../constants/mealAccents";

function Skel({ w = "100%", h, r = "14px", style = {} }) {
  return (
    <div style={{
      width: w, height: h, borderRadius: r, flexShrink: 0,
      background: "linear-gradient(90deg,#E8DFD0 25%,#F4EDE2 50%,#E8DFD0 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.4s ease infinite",
      ...style,
    }} />
  );
}

const mealIcons = {
  breakfast: (
    <svg viewBox="0 0 262 262" width="19" height="19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M122.062 34.875V8.71875C122.062 6.40639 122.981 4.18875 124.616 2.55366C126.251 0.91858 128.469 0 130.781 0C133.094 0 135.311 0.91858 136.946 2.55366C138.581 4.18875 139.5 6.40639 139.5 8.71875V34.875C139.5 37.1874 138.581 39.405 136.946 41.0401C135.311 42.6752 133.094 43.5938 130.781 43.5938C128.469 43.5938 126.251 42.6752 124.616 41.0401C122.981 39.405 122.062 37.1874 122.062 34.875ZM200.531 130.781C200.531 144.576 196.44 158.062 188.776 169.532C181.112 181.003 170.219 189.943 157.473 195.222C144.728 200.501 130.704 201.882 117.174 199.191C103.644 196.5 91.2153 189.857 81.4605 180.102C71.7058 170.347 65.0628 157.919 62.3715 144.389C59.6802 130.859 61.0614 116.834 66.3407 104.089C71.6199 91.3439 80.5599 80.4505 92.0302 72.7862C103.501 65.122 116.986 61.0313 130.781 61.0312C149.274 61.0514 167.003 68.4066 180.08 81.4829C193.156 94.5591 200.511 112.289 200.531 130.781ZM183.094 130.781C183.094 120.435 180.026 110.321 174.278 101.718C168.529 93.1152 160.359 86.4102 150.8 82.4508C141.242 78.4914 130.723 77.4554 120.576 79.4739C110.428 81.4924 101.107 86.4747 93.7907 93.7907C86.4747 101.107 81.4924 110.428 79.4739 120.576C77.4554 130.723 78.4914 141.242 82.4508 150.8C86.4102 160.359 93.1152 168.529 101.718 174.278C110.321 180.026 120.435 183.094 130.781 183.094C144.651 183.079 157.948 177.563 167.756 167.756C177.563 157.948 183.079 144.651 183.094 130.781ZM54.8627 67.1998C56.4987 68.8358 58.7176 69.7548 61.0312 69.7548C63.3449 69.7548 65.5638 68.8358 67.1998 67.1998C68.8358 65.5638 69.7548 63.3449 69.7548 61.0312C69.7548 58.7176 68.8358 56.4987 67.1998 54.8627L49.7623 37.4252C48.1263 35.7892 45.9074 34.8702 43.5938 34.8702C41.2801 34.8702 39.0612 35.7892 37.4252 37.4252C35.7892 39.0612 34.8702 41.2801 34.8702 43.5938C34.8702 45.9074 35.7892 48.1263 37.4252 49.7623L54.8627 67.1998ZM54.8627 194.363L37.4252 211.8C35.7892 213.436 34.8702 215.655 34.8702 217.969C34.8702 220.282 35.7892 222.501 37.4252 224.137C39.0612 225.773 41.2801 226.692 43.5938 226.692C45.9074 226.692 48.1263 225.773 49.7623 224.137L67.1998 206.7C68.0098 205.89 68.6524 204.928 69.0908 203.87C69.5292 202.811 69.7548 201.677 69.7548 200.531C69.7548 199.386 69.5292 198.251 69.0908 197.193C68.6524 196.134 68.0098 195.173 67.1998 194.363C66.3897 193.553 65.428 192.91 64.3696 192.472C63.3112 192.033 62.1768 191.808 61.0312 191.808C59.8857 191.808 58.7513 192.033 57.6929 192.472C56.6345 192.91 55.6728 193.553 54.8627 194.363ZM200.531 69.75C201.677 69.7509 202.811 69.5261 203.869 69.0886C204.928 68.651 205.889 68.0092 206.7 67.1998L224.137 49.7623C225.773 48.1263 226.692 45.9074 226.692 43.5938C226.692 41.2801 225.773 39.0612 224.137 37.4252C222.501 35.7892 220.282 34.8702 217.969 34.8702C215.655 34.8702 213.436 35.7892 211.8 37.4252L194.363 54.8627C193.142 56.0821 192.311 57.6362 191.974 59.3284C191.637 61.0206 191.809 62.7747 192.47 64.3687C193.13 65.9627 194.249 67.3249 195.684 68.2828C197.119 69.2407 198.806 69.7514 200.531 69.75ZM206.7 194.363C205.064 192.727 202.845 191.808 200.531 191.808C198.218 191.808 195.999 192.727 194.363 194.363C192.727 195.999 191.808 198.218 191.808 200.531C191.808 202.845 192.727 205.064 194.363 206.7L211.8 224.137C212.61 224.947 213.572 225.59 214.63 226.028C215.689 226.467 216.823 226.692 217.969 226.692C219.114 226.692 220.249 226.467 221.307 226.028C222.366 225.59 223.327 224.947 224.137 224.137C224.947 223.327 225.59 222.366 226.028 221.307C226.467 220.249 226.692 219.114 226.692 217.969C226.692 216.823 226.467 215.689 226.028 214.63C225.59 213.572 224.947 212.61 224.137 211.8L206.7 194.363ZM43.5938 130.781C43.5938 128.469 42.6752 126.251 41.0401 124.616C39.405 122.981 37.1874 122.062 34.875 122.062H8.71875C6.40639 122.062 4.18875 122.981 2.55366 124.616C0.91858 126.251 0 128.469 0 130.781C0 133.094 0.91858 135.311 2.55366 136.946C4.18875 138.581 6.40639 139.5 8.71875 139.5H34.875C37.1874 139.5 39.405 138.581 41.0401 136.946C42.6752 135.311 43.5938 133.094 43.5938 130.781ZM130.781 217.969C128.469 217.969 126.251 218.887 124.616 220.522C122.981 222.157 122.062 224.375 122.062 226.688V252.844C122.062 255.156 122.981 257.374 124.616 259.009C126.251 260.644 128.469 261.562 130.781 261.562C133.094 261.562 135.311 260.644 136.946 259.009C138.581 257.374 139.5 255.156 139.5 252.844V226.688C139.5 224.375 138.581 222.157 136.946 220.522C135.311 218.887 133.094 217.969 130.781 217.969ZM252.844 122.062H226.688C224.375 122.062 222.157 122.981 220.522 124.616C218.887 126.251 217.969 128.469 217.969 130.781C217.969 133.094 218.887 135.311 220.522 136.946C222.157 138.581 224.375 139.5 226.688 139.5H252.844C255.156 139.5 257.374 138.581 259.009 136.946C260.644 135.311 261.562 133.094 261.562 130.781C261.562 128.469 260.644 126.251 259.009 124.616C257.374 122.981 255.156 122.062 252.844 122.062Z"/>
    </svg>
  ),
  lunch: (
    <svg width="17" height="17" viewBox="0 0 136 136" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M130.469 57.4063H5.21875C3.83465 57.4063 2.50724 57.9562 1.52854 58.9349C0.549831 59.9136 0 61.241 0 62.6251C0.0229299 75.036 3.43845 87.2046 9.87721 97.8147C16.316 108.425 25.5329 117.073 36.5312 122.823V125.25C36.5312 128.018 37.6309 130.673 39.5883 132.63C41.5457 134.588 44.2006 135.688 46.9688 135.688H88.7188C91.4869 135.688 94.1418 134.588 96.0992 132.63C98.0566 130.673 99.1562 128.018 99.1562 125.25V122.823C110.155 117.073 119.372 108.425 125.81 97.8147C132.249 87.2046 135.665 75.036 135.688 62.6251C135.688 61.241 135.138 59.9136 134.159 58.9349C133.18 57.9562 131.853 57.4063 130.469 57.4063ZM91.7587 114.813C90.8514 115.229 90.0827 115.898 89.5439 116.738C89.005 117.579 88.7187 118.557 88.7188 119.555V125.25H46.9688V119.568C46.9713 118.567 46.6861 117.587 46.1472 116.744C45.6082 115.901 44.8381 115.23 43.9288 114.813C34.7511 110.589 26.8457 104.026 21.0062 95.7821C15.1666 87.538 11.5982 77.9029 10.6593 67.8438H125.009C124.072 77.9008 120.506 87.5346 114.67 95.7785C108.834 104.022 100.933 110.587 91.7587 114.813ZM37.6859 20.2227C41.1759 15.8781 42.037 12.9426 41.6782 11.6509C41.4043 10.6789 40.1061 10.1766 40.093 10.1766C38.9117 9.78841 37.9079 8.99115 37.2622 7.92843C36.6166 6.86571 36.3716 5.60738 36.5715 4.38007C36.7713 3.15277 37.4028 2.03714 38.3522 1.23413C39.3016 0.431117 40.5065 -0.00650817 41.75 7.31635e-05C42.2763 0.000689372 42.7996 0.0798426 43.3026 0.234917C43.9549 0.437144 49.7673 2.40722 51.6461 8.55882C53.2508 13.8232 51.2873 19.9422 45.8141 26.7527C42.3241 31.0973 41.463 34.0328 41.8218 35.3245C42.0957 36.2965 43.3678 36.7857 43.3809 36.7923C44.56 37.1798 45.5624 37.9749 46.2081 39.0349C46.8539 40.0949 47.1007 41.3503 46.9043 42.5759C46.7079 43.8014 46.0811 44.9168 45.1365 45.722C44.1918 46.5271 42.9912 46.9691 41.75 46.9688C41.2237 46.9682 40.7004 46.8891 40.1974 46.734C39.5451 46.5317 33.7327 44.5617 31.8539 38.4101C30.2492 33.1457 32.2127 27.0267 37.6859 20.2227ZM63.7796 20.2227C67.2697 15.8781 68.1308 12.9426 67.772 11.6509C67.498 10.6789 66.1998 10.1766 66.1868 10.1766C65.0055 9.78841 64.0016 8.99115 63.356 7.92843C62.7103 6.86571 62.4654 5.60738 62.6652 4.38007C62.865 3.15277 63.4965 2.03714 64.4459 1.23413C65.3954 0.431117 66.6003 -0.00650817 67.8438 7.31635e-05C68.3701 0.000689372 68.8934 0.0798426 69.3963 0.234917C70.0487 0.437144 75.8611 2.40722 77.7398 8.55882C79.3446 13.8232 77.381 19.9422 71.9078 26.7527C68.4178 31.0973 67.5567 34.0328 67.9155 35.3245C68.1895 36.2965 69.4616 36.7857 69.4746 36.7923C70.6537 37.1798 71.6561 37.9749 72.3019 39.0349C72.9476 40.0949 73.1945 41.3503 72.9981 42.5759C72.8017 43.8014 72.1749 44.9168 71.2302 45.722C70.2856 46.5271 69.0849 46.9691 67.8438 46.9688C67.3174 46.9682 66.7941 46.8891 66.2912 46.734C65.6388 46.5317 59.8264 44.5617 57.9477 38.4101C56.3429 33.1457 58.3065 27.0267 63.7796 20.2227ZM89.8734 20.2227C93.3634 15.8781 94.2245 12.9426 93.8657 11.6509C93.5918 10.6789 92.2936 10.1766 92.2806 10.1766C91.0992 9.78841 90.0954 8.99115 89.4497 7.92843C88.8041 6.86571 88.5591 5.60738 88.759 4.38007C88.9588 3.15277 89.5903 2.03714 90.5397 1.23413C91.4891 0.431117 92.694 -0.00650817 93.9375 7.31635e-05C94.4638 0.000689372 94.9871 0.0798426 95.4901 0.234917C96.1424 0.437144 101.955 2.40722 103.834 8.55882C105.438 13.8232 103.475 19.9422 98.0016 26.7527C94.5116 31.0973 93.6505 34.0328 94.0093 35.3245C94.2832 36.2965 95.5553 36.7857 95.5684 36.7923C96.7475 37.1798 97.7499 37.9749 98.3956 39.0349C99.0414 40.0949 99.2882 41.3503 99.0918 42.5759C98.8954 43.8014 98.2686 44.9168 97.324 45.722C96.3793 46.5271 95.1787 46.9691 93.9375 46.9688C93.4112 46.9682 92.8879 46.8891 92.3849 46.734C91.7326 46.5317 85.9202 44.5617 84.0414 38.4101C82.4367 33.1457 84.4002 27.0267 89.8734 20.2227Z" fill="#697B6A"/>
</svg>
  ),
  dinner: (
    <svg width="17" height="17" viewBox="0 0 121 132" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26.0938 36.8352V5.33518C26.0938 3.94279 26.6436 2.60744 27.6223 1.62287C28.601 0.638304 29.9285 0.0851795 31.3125 0.0851795C32.6966 0.0851795 34.0241 0.638304 35.0028 1.62287C35.9815 2.60744 36.5313 3.94279 36.5313 5.33518V36.8352C36.5313 38.2276 35.9815 39.5629 35.0028 40.5475C34.0241 41.5321 32.6966 42.0852 31.3125 42.0852C29.9285 42.0852 28.601 41.5321 27.6223 40.5475C26.6436 39.5629 26.0938 38.2276 26.0938 36.8352ZM120.031 5.33518V126.085C120.031 127.478 119.481 128.813 118.503 129.797C117.524 130.782 116.197 131.335 114.813 131.335C113.428 131.335 112.101 130.782 111.122 129.797C110.144 128.813 109.594 127.478 109.594 126.085V94.5852H78.2813C76.8972 94.5852 75.5698 94.0321 74.5911 93.0475C73.6124 92.0629 73.0625 90.7276 73.0625 89.3352C73.3049 76.7593 74.8838 64.2456 77.7725 52.0077C84.1524 25.4361 96.2469 7.62549 112.758 0.511743C113.551 0.169773 114.417 0.0311976 115.277 0.108436C116.137 0.185674 116.964 0.476313 117.685 0.954308C118.406 1.4323 118.997 2.08272 119.407 2.84729C119.816 3.61186 120.031 4.46669 120.031 5.33518ZM109.594 14.4571C88.6079 30.5811 84.4981 69.8577 83.6958 84.0852H109.594V14.4571ZM57.3345 4.47549C57.2323 3.78613 56.9947 3.12414 56.6355 2.52815C56.2763 1.93215 55.8027 1.41406 55.2424 1.00412C54.6821 0.594173 54.0462 0.300572 53.3719 0.140439C52.6976 -0.0196935 51.9983 -0.0431518 51.3149 0.0714321C50.6315 0.186016 49.9776 0.43635 49.3914 0.80783C48.8052 1.17931 48.2983 1.6645 47.9005 2.2351C47.5026 2.8057 47.2216 3.45029 47.074 4.13127C46.9264 4.81225 46.915 5.51598 47.0406 6.20143L52.1875 37.2486C52.1875 42.8182 49.9882 48.1596 46.0734 52.0979C42.1586 56.0361 36.8489 58.2486 31.3125 58.2486C25.7762 58.2486 20.4665 56.0361 16.5517 52.0979C12.6369 48.1596 10.4375 42.8182 10.4375 37.2486L15.578 6.20143C15.7036 5.51598 15.6922 4.81225 15.5446 4.13127C15.3969 3.45029 15.116 2.8057 14.7181 2.2351C14.3202 1.6645 13.8134 1.17931 13.2272 0.80783C12.6409 0.43635 11.9871 0.186016 11.3036 0.0714321C10.6202 -0.0431518 9.92098 -0.0196935 9.24667 0.140439C8.57237 0.300572 7.93651 0.594173 7.37618 1.00412C6.81586 1.41406 6.34228 1.93215 5.98308 2.52815C5.62388 3.12414 5.38624 3.78613 5.28403 4.47549L0.0652827 35.9755C0.0206323 36.2598 -0.00118205 36.5473 4.93521e-05 36.8352C0.0104769 44.2758 2.63498 51.4732 7.40981 57.1557C12.1846 62.8381 18.8024 66.6398 26.0938 67.8889V126.085C26.0938 127.478 26.6436 128.813 27.6223 129.797C28.601 130.782 29.9285 131.335 31.3125 131.335C32.6966 131.335 34.0241 130.782 35.0028 129.797C35.9815 128.813 36.5313 127.478 36.5313 126.085V67.8889C43.8227 66.6398 50.4405 62.8381 55.2153 57.1557C59.9901 51.4732 62.6146 44.2758 62.625 36.8352C62.6241 36.5471 62.6001 36.2597 62.5533 35.9755L57.3345 4.47549Z" fill="#E67260"/>
</svg>
  ),
  snacks: (
    <svg width="18" height="18" viewBox="0 0 205 205" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M138.295 137.33C139.943 138.984 141.064 141.089 141.516 143.379C141.969 145.669 141.732 148.042 140.837 150.198C139.942 152.354 138.428 154.197 136.486 155.493C134.544 156.789 132.262 157.481 129.928 157.481C127.593 157.481 125.311 156.789 123.369 155.493C121.428 154.197 119.914 152.354 119.018 150.198C118.123 148.042 117.887 145.669 118.339 143.379C118.792 141.089 119.913 138.984 121.561 137.33C122.658 136.229 123.962 135.355 125.398 134.759C126.834 134.163 128.373 133.856 129.928 133.856C131.482 133.856 133.022 134.163 134.458 134.759C135.893 135.355 137.197 136.229 138.295 137.33ZM58.5605 129.455C56.9126 131.109 55.7916 133.214 55.3392 135.504C54.8867 137.794 55.123 140.167 56.0183 142.323C56.9136 144.479 58.4276 146.322 60.3693 147.618C62.311 148.914 64.5932 149.606 66.9277 149.606C69.2622 149.606 71.5444 148.914 73.4861 147.618C75.4278 146.322 76.9418 144.479 77.8371 142.323C78.7324 140.167 78.9687 137.794 78.5162 135.504C78.0638 133.214 76.9428 131.109 75.2949 129.455C74.1978 128.357 72.895 127.486 71.461 126.891C70.027 126.297 68.4899 125.991 66.9375 125.991C65.3852 125.991 63.8481 126.297 62.4141 126.891C60.98 127.486 59.6773 128.357 58.5802 129.455H58.5605ZM67.4199 91.0645C69.0678 89.4109 70.1888 87.306 70.6412 85.0158C71.0937 82.7255 70.8574 80.3525 69.9621 78.1964C69.0668 76.0404 67.5528 74.1979 65.6111 72.9018C63.6694 71.6056 61.3872 70.9138 59.0527 70.9138C56.7182 70.9138 54.436 71.6056 52.4943 72.9018C50.5526 74.1979 49.0386 76.0404 48.1433 78.1964C47.248 80.3525 47.0117 82.7255 47.4642 85.0158C47.9166 87.306 49.0376 89.4109 50.6855 91.0645C51.7842 92.1645 53.0893 93.0367 54.5258 93.6312C55.9623 94.2257 57.5021 94.5308 59.0568 94.529C60.6115 94.5272 62.1505 94.2185 63.5856 93.6206C65.0208 93.0227 66.3238 92.1474 67.4199 91.0448V91.0645ZM114.67 90.0802C113.016 88.4323 110.911 87.3113 108.621 86.8588C106.331 86.4064 103.958 86.6427 101.802 87.5379C99.6457 88.4332 97.8033 89.9473 96.5071 91.8889C95.211 93.8306 94.5192 96.1128 94.5192 98.4473C94.5192 100.782 95.211 103.064 96.5071 105.006C97.8033 106.947 99.6457 108.461 101.802 109.357C103.958 110.252 106.331 110.488 108.621 110.036C110.911 109.583 113.016 108.462 114.67 106.815C115.771 105.717 116.645 104.413 117.241 102.977C117.837 101.541 118.144 100.002 118.144 98.4473C118.144 96.8927 117.837 95.3533 117.241 93.9174C116.645 92.4816 115.771 91.1776 114.67 90.0802ZM204.75 102.375C204.75 122.623 198.746 142.416 187.497 159.251C176.248 176.087 160.259 189.209 141.552 196.957C122.846 204.706 102.261 206.733 82.4027 202.783C62.5439 198.833 44.3024 189.082 29.985 174.765C15.6676 160.448 5.91732 142.206 1.96715 122.347C-1.98301 102.489 0.0443575 81.9044 7.79288 63.1978C15.5414 44.4912 28.6631 28.5024 45.4985 17.2533C62.334 6.00419 82.1272 0 102.375 0C104.464 0 106.467 0.829685 107.944 2.30653C109.42 3.78338 110.25 5.78642 110.25 7.875C110.25 18.3179 114.398 28.3331 121.783 35.7173C129.167 43.1016 139.182 47.25 149.625 47.25C151.714 47.25 153.717 48.0797 155.194 49.5565C156.67 51.0334 157.5 53.0364 157.5 55.125C157.5 65.5679 161.648 75.5831 169.033 82.9673C176.417 90.3516 186.432 94.5 196.875 94.5C198.964 94.5 200.967 95.3297 202.444 96.8065C203.92 98.2834 204.75 100.286 204.75 102.375ZM188.695 109.65C176.901 107.859 166.002 102.3 157.629 93.8032C149.256 85.306 143.858 74.3272 142.242 62.5078C130.423 60.8916 119.444 55.4936 110.947 47.1206C102.45 38.7476 96.8905 27.8494 95.1005 16.0552C78.6459 17.442 62.9306 23.5031 49.806 33.5243C36.6815 43.5455 26.6947 57.1091 21.0223 72.6172C15.3499 88.1253 14.2282 104.932 17.7894 121.056C21.3507 137.18 29.4464 151.951 41.1228 163.627C52.7992 175.304 67.5698 183.399 83.6941 186.961C99.8184 190.522 116.625 189.4 132.133 183.728C147.641 178.055 161.205 168.069 171.226 154.944C181.247 141.819 187.308 126.104 188.695 109.65Z" fill="#CFC4B8"/>
</svg>
  )
};

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

function ManualIllustration() {
  return <img src={manualIllustration} width={280} style={{ display: "block" }} alt="" />;
}

function ProgrammeIllustration() {
  return <img src={programmeIllustration} width={220} style={{ display: "block" }} alt="" />;
}

function PlanTab({
  planningMode,
  setPlanningMode,
  isMobile,
  formatWeekBeginning,
  planCalendarWeekOffset,
  getMealsPlannedThisWeek,
  generateWeek,
  appTheme,
  getDateKey,
  shuffleWeek,
  setShowClearPlanConfirm,
  setShowRemoveAllWeeksConfirm,
  secondaryButtonStyle,
  showClearPlanConfirm,
  clearEntirePlan,
  showRemoveAllWeeksConfirm,
  removeAllWeeks,
  hoveredButton,
  setHoveredButton,
  setDailyNotes, // receives saveDailyNote(dateKey, note) from App.js
  setPlanCalendarWeekOffset,
  getPlanCalendarDays,
  setSelectedPlanDay,
  selectedPlanDay,
  plan,
  completedMeals,
  openMealSlotSheet,
  openMealChoice,
  removeFromPlan,
  smallSecondaryButtonStyle,
  completeMeal,
  expandedMacroDays,
  toggleMacroDay,
  cardStyle,
  dailyNotes,
  selectedProgramme,
  viewSelectedProgramme,
  setActiveTab,
  currentProgrammeWeekIndex,
  getProgrammeWeekCount,
  switchProgrammeWeek,
  currentProgrammeProgress,
  goToProgrammeWeek,
  currentProgrammeWeek,
  days,
  startProgrammeMealSwap,
  setShowFullWeek,
  openManualEntryModal,
  removeSnack,
  filteredProgrammes,
  openProgrammeDetails,
  chooseProgramme,
  quitProgramme,
  clearSelectedProgramme,
  restartProgramme,
  favouriteRecipes,
  toggleFavourite,
  openRecipeDetails,
  getRecipeByName,
  isLoading,
  hasCreatedManualPlan,
  hasChosenProgramme,
  onCreateManualPlan,
  onChooseProgramme,
}) {
  const [showManualMenu, setShowManualMenu] = useState(false);
  const [showProgrammeMenu, setShowProgrammeMenu] = useState(false);
  const [showRestartConfirm, setShowRestartConfirm] = useState(false);
  const [showQuitConfirm, setShowQuitConfirm] = useState(false);
  const [isChangingProgramme, setIsChangingProgramme] = useState(false);
  const [showWeekDropdown, setShowWeekDropdown] = useState(false);
  // PROGRAMME GATE — remove this line to re-enable programme mode
  const [showProgrammeSheet, setShowProgrammeSheet] = useState(false);
  const [mealMenuOpen, setMealMenuOpen] = useState(null);
  const dayStripRef = useRef(null);
  const programmeDayStripRef = useRef(null);
  const prevProgrammeIdRef = useRef(selectedProgramme?.id);
  const [selectedProgrammeDay, setSelectedProgrammeDay] = useState(null);

  // hasCreatedManualPlan and hasChosenProgramme are now Supabase-backed (user_profiles)
  // and passed as props from App.js — no localStorage dependency.
  function handleCreatePlan() {
    onCreateManualPlan();
  }

  function handleChooseProgramme() {
    clearSelectedProgramme();
    onChooseProgramme();
  }

  // Exit "changing programme" state only when the selected programme actually changes
  useEffect(() => {
    if (isChangingProgramme && selectedProgramme?.id !== prevProgrammeIdRef.current) {
      setIsChangingProgramme(false);
    }
    prevProgrammeIdRef.current = selectedProgramme?.id;
  }, [selectedProgramme]); // eslint-disable-line react-hooks/exhaustive-deps

// Scroll selected day into view (manual)
  useEffect(() => {
    if (dayStripRef.current && selectedPlanDay) {
      const selected = dayStripRef.current.querySelector("[data-selected='true']");
      if (selected) {
        selected.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    }
  }, [selectedPlanDay]);

  // Scroll active programme day into centre on mount and when it changes
  useEffect(() => {
    const container = programmeDayStripRef.current;
    if (!container) return;
    const active = container.querySelector("[data-active-prog='true']");
    if (!active) return;
    const containerCenter = container.offsetWidth / 2;
    const btnCenter = active.offsetLeft + active.offsetWidth / 2;
    container.scrollTo({ left: btnCenter - containerCenter, behavior: "smooth" });
  }, [selectedProgrammeDay, currentProgrammeWeekIndex]);

  const todayDateKey = getDateKey(new Date());
  const weekDays = getPlanCalendarDays(planCalendarWeekOffset);
  const activeDateKey = selectedPlanDay || todayDateKey;
  const dayPlan = plan[activeDateKey] || {};
  
  useEffect(() => {
  setSelectedPlanDay(todayDateKey);
}, [todayDateKey, setSelectedPlanDay]);

  // ─── Landing Screen ───────────────────────────────────────────
  if ((planningMode === "manual" && !hasCreatedManualPlan) ||
    (planningMode === "programme" && !hasChosenProgramme)) {
    const isManual = planningMode === "manual";
    return (
      <>
        <div style={{ marginBottom: "20px" }}>
          <div style={{
            fontFamily: appTheme.fontHeading,
            fontSize: isMobile ? "24px" : "30px",
            fontWeight: "600",
            color: appTheme.primaryText,
            lineHeight: 1.15,
            marginBottom: "4px"
          }}>
            Plan
          </div>
          <div style={{ fontSize: "14px", color: appTheme.secondaryText }}>
            How would you like to plan?
          </div>
        </div>

        {/* Toggle */}
        <div style={{
          display: "flex",
          padding: "3px",
          borderRadius: "999px",
          background: appTheme.softBackground,
          border: appTheme.cardBorder,
          gap: "2px",
          marginBottom: "14px"
        }}>
          {["manual", "programme"].map((mode) => (
            <button
              key={mode}
              // PROGRAMME GATE — restore to: onClick={() => setPlanningMode(mode)}
              onClick={() => mode === "programme" ? setShowProgrammeSheet(true) : setPlanningMode(mode)}
              style={{
                flex: 1,
                padding: "10px 16px",
                borderRadius: "999px",
                border: "none",
                background: planningMode === mode ? appTheme.accentColor : "transparent",
                color: planningMode === mode ? "#ffffff" : appTheme.secondaryText,
                fontWeight: planningMode === mode ? "700" : "500",
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.18s ease",
                textTransform: "capitalize",
                // PROGRAMME GATE — remove this line to re-enable programme mode
                opacity: mode === "programme" ? 0.5 : 1,
              }}
            >
              {mode === "manual" ? "Manual" : "Programme"}
            </button>
          ))}
        </div>

        {/* Illustration */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "220px" }}>
          {isManual ? <ManualIllustration /> : <ProgrammeIllustration />}
        </div>

        {/* Mode title + description */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{
            fontFamily: appTheme.fontHeading,
            fontSize: isMobile ? "22px" : "26px",
            fontWeight: "500",
            color: appTheme.primaryText,
            marginBottom: "10px"
          }}>
            {isManual ? "Manual mode" : "Programme mode"}
          </div>
          <div style={{
            fontSize: "14px",
            color: appTheme.secondaryText,
            lineHeight: 1.6,
            maxWidth: "280px",
            margin: "0 auto"
          }}>
            {isManual
              ? "Pick and choose your favourite recipes and build your plan your way."
              : "Follow a curated programme with everything planned out for you."}
          </div>
        </div>

        {/* Bullet points */}
        <div style={{ display: "grid", gap: "12px", marginBottom: "32px", maxWidth: "300px", margin: "0 auto 32px" }}>
          {(isManual
            ? ["Full freedom to choose", "Add or swap recipes anytime", "Perfect for flexible planning"]
            : ["Expertly designed programmes", "Balanced & goal-focused", "Just follow and enjoy"]
          ).map((point) => (
            <div key={point} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{
                width: "22px", height: "22px", borderRadius: "999px",
                background: appTheme.accentLight,
                border: appTheme.accentBorder,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: appTheme.accentColor, flexShrink: 0
              }}>
                <CheckIcon />
              </div>
              <div style={{ fontSize: "14px", color: appTheme.primaryText, fontWeight: "500" }}>
                {point}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={isManual ? handleCreatePlan : handleChooseProgramme}
          style={{
            width: "100%",
            padding: "16px",
            borderRadius: "16px",
            border: "none",
            background: appTheme.accentColor,
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: "700",
            cursor: "pointer",
            transition: "all 0.18s ease"
          }}
        >
          {isManual ? "Create your own plan" : "Choose a programme"}
        </button>

        <div style={{ height: isMobile ? "100px" : "40px" }} />
      </>
    );
  }

  // ─── Main Plan View ───────────────────────────────────────────
  return (
    <>
      {/* Header row — title + toggle + icons */}
      {(planningMode === "manual" || (planningMode === "programme" && selectedProgramme && !isChangingProgramme)) && (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        marginBottom: "16px"
      }}>
        <div style={{
          fontFamily: appTheme.fontHeading,
          fontSize: isMobile ? "24px" : "30px",
          fontWeight: "600",
          color: appTheme.primaryText,
          lineHeight: 1.1
        }}>
          Plan
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Full week calendar icon */}
          <button
            onClick={() => setShowFullWeek(true)}
            style={{
              width: "36px", height: "36px", borderRadius: "10px",
              border: appTheme.accentBorder, background: appTheme.accentLight,
              color: appTheme.accentColor, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0, transition: "all 0.18s ease"
            }}
          >
            <svg width="18" height="20" viewBox="0 0 192 208" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M176 24H16C11.5817 24 8 27.5817 8 32V192C8 196.418 11.5817 200 16 200H176C180.418 200 184 196.418 184 192V32C184 27.5817 180.418 24 176 24Z" stroke="currentColor" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M144 8V40" stroke="currentColor" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M48 8V40" stroke="currentColor" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 72H184" stroke="currentColor" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M96 128C102.627 128 108 122.627 108 116C108 109.373 102.627 104 96 104C89.3726 104 84 109.373 84 116C84 122.627 89.3726 128 96 128Z" fill="#E67260"/>
              <path d="M140 128C146.627 128 152 122.627 152 116C152 109.373 146.627 104 140 104C133.373 104 128 109.373 128 116C128 122.627 133.373 128 140 128Z" fill="#F6BC63"/>
              <path d="M52 168C58.6274 168 64 162.627 64 156C64 149.373 58.6274 144 52 144C45.3726 144 40 149.373 40 156C40 162.627 45.3726 168 52 168Z" fill="#697B6A"/>
              <path d="M96 168C102.627 168 108 162.627 108 156C108 149.373 102.627 144 96 144C89.3726 144 84 149.373 84 156C84 162.627 89.3726 168 96 168Z" fill="#CFC4B8"/>
              <path d="M140 168C146.627 168 152 162.627 152 156C152 149.373 146.627 144 140 144C133.373 144 128 149.373 128 156C128 162.627 133.373 168 140 168Z" fill="#5ECCDD"/>
            </svg>
          </button>

          {/* Three dot menu */}
          <div style={{ position: "relative" }}>
            <button
              onClick={() => planningMode === "manual"
                ? setShowManualMenu(prev => !prev)
                : setShowProgrammeMenu(prev => !prev)
              }
              style={{
                width: "36px", height: "36px", borderRadius: "10px",
                border: appTheme.pillBorder, background: appTheme.pillBackground,
                color: appTheme.secondaryText, fontSize: "18px", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0
              }}
            >
              ⋯
            </button>

            {/* Manual menu */}
            {showManualMenu && planningMode === "manual" && (
              <>
                <div onClick={() => setShowManualMenu(false)} style={{ position: "fixed", inset: 0, zIndex: 99 }} />
                <div style={{
                  position: "absolute", top: "42px", right: "0", zIndex: 100,
                  width: "200px", borderRadius: "16px",
                  background: appTheme.accentColor,
                  boxShadow: "0 12px 32px rgba(15,23,42,0.18)",
                  overflow: "hidden"
                }}>
                  {[
                    { label: "Generate week", action: () => { generateWeek(); setShowManualMenu(false); } },
                    { label: "Shuffle week", action: () => { shuffleWeek(); setShowManualMenu(false); } },
                    { label: "Clear week", action: () => { setShowClearPlanConfirm(true); setShowManualMenu(false); }, danger: false }
                  ].map((item, index, arr) => (
                    <div key={item.label}>
                      <button onClick={item.action} style={{
                        width: "100%", padding: "13px 16px", border: "none",
                        background: "transparent",
                        color: item.danger ? "rgba(255,180,180,1)" : "#ffffff",
                        fontSize: "14px", fontWeight: "600", textAlign: "left", cursor: "pointer"
                      }}>
                        {item.label}
                      </button>
                      {index < arr.length - 1 && (
                        <div style={{ height: "1px", background: "rgba(255,255,255,0.18)", margin: "0 16px" }} />
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Programme menu */}
            {showProgrammeMenu && planningMode === "programme" && selectedProgramme && (
              <>
                <div onClick={() => setShowProgrammeMenu(false)} style={{ position: "fixed", inset: 0, zIndex: 99 }} />
                <div style={{
                  position: "absolute", top: "42px", right: "0", zIndex: 100,
                  width: "220px", borderRadius: "16px",
                  background: appTheme.accentColor,
                  boxShadow: "0 12px 32px rgba(15,23,42,0.18)",
                  overflow: "hidden"
                }}>
                  {[
                    { label: "View Programme", action: () => { viewSelectedProgramme(); setShowProgrammeMenu(false); } },
                    { label: "Change Programme", action: () => { setIsChangingProgramme(true); setShowProgrammeMenu(false); } },
                    { label: "Restart Programme", action: () => { setShowRestartConfirm(true); setShowProgrammeMenu(false); } },
                    { label: "Leave Programme", action: () => { setShowQuitConfirm(true); setShowProgrammeMenu(false); }, danger: true }
                  ].map((item, index, arr) => (
                    <div key={item.label}>
                      <button onClick={item.action} style={{
                        width: "100%", padding: "13px 16px", border: "none",
                        background: "transparent",
                        color: item.danger ? "rgba(255,180,180,1)" : "#ffffff",
                        fontSize: "14px", fontWeight: item.danger ? "700" : "600",
                        textAlign: "left", cursor: "pointer"
                      }}>
                        {item.label}
                      </button>
                      {index < arr.length - 1 && (
                        <div style={{ height: "1px", background: "rgba(255,255,255,0.18)", margin: "0 16px" }} />
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      )}

      {/* Toggle */}
      <div style={{
        display: "flex",
        padding: "3px",
        borderRadius: "999px",
        background: appTheme.softBackground,
        border: appTheme.cardBorder,
        gap: "2px",
        marginBottom: "16px"
      }}>
        {["manual", "programme"].map((mode) => (
          <button
            key={mode}
            // PROGRAMME GATE — restore to: onClick={() => setPlanningMode(mode)}
            onClick={() => mode === "programme" ? setShowProgrammeSheet(true) : setPlanningMode(mode)}
            style={{
              flex: 1, padding: "10px 16px", borderRadius: "999px", border: "none",
              background: planningMode === mode ? appTheme.accentColor : "transparent",
              color: planningMode === mode ? "#ffffff" : appTheme.secondaryText,
              fontWeight: planningMode === mode ? "700" : "500",
              fontSize: "14px", cursor: "pointer", transition: "all 0.18s ease",
              textTransform: "capitalize",
              // PROGRAMME GATE — remove this line to re-enable programme mode
              opacity: mode === "programme" ? 0.5 : 1,
            }}
          >
            {mode === "manual" ? "Manual" : "Programme"}
          </button>
        ))}
      </div>

      {/* ─── MANUAL MODE ─────────────────────────────────────── */}
      {planningMode === "manual" && (
        <>
          {/* Week navigation row */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "14px" }}>
            <button
              onClick={() => {
                const newOffset = planCalendarWeekOffset - 1;
                setPlanCalendarWeekOffset(newOffset);
                const newWeekDays = getPlanCalendarDays(newOffset);
                const currentDayIndex = weekDays.findIndex(d => getDateKey(d) === activeDateKey);
                const targetIndex = currentDayIndex >= 0 ? currentDayIndex : 0;
                setSelectedPlanDay(getDateKey(newWeekDays[targetIndex]));
              }}
              style={{ width: "32px", height: "32px", borderRadius: "999px", border: appTheme.pillBorder, background: appTheme.pillBackground, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
            >
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M6 1L1 6l5 5" stroke={appTheme.primaryText} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>

            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
              <div style={{ fontFamily: appTheme.fontHeading, fontSize: isMobile ? "18px" : "22px", fontWeight: "500", color: appTheme.primaryText, textAlign: "center" }}>
                {(() => {
                  const first = weekDays[0];
                  const last = weekDays[weekDays.length - 1];
                  const fmt = (d) => d.toLocaleDateString("en-GB", { day: "numeric", month: "long" });
                  return `${fmt(first)} – ${fmt(last)}`;
                })()}
              </div>
              {planCalendarWeekOffset !== 0 && (
                <button
                  onClick={() => {
                    setPlanCalendarWeekOffset(0);
                    setSelectedPlanDay(getDateKey(new Date()));
                  }}
                  title="Back to current week"
                  style={{ background: "none", border: "none", cursor: "pointer", padding: "2px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                >
                  {(() => {
                    const today = new Date();
                    const daysToMonday = (today.getDay() + 6) % 7;
                    const monday = new Date(today);
                    monday.setDate(today.getDate() - daysToMonday);
                    const mondayDate = monday.getDate();
                    return (
                      <svg viewBox="0 0 225 244" width="17" height="18" fill="none">
                        <path d="M206.25 18.75H178.125V9.375C178.125 6.8886 177.137 4.50403 175.379 2.74587C173.621 0.98772 171.236 0 168.75 0C166.264 0 163.879 0.98772 162.121 2.74587C160.363 4.50403 159.375 6.8886 159.375 9.375V18.75H65.625V9.375C65.625 6.8886 64.6373 4.50403 62.8791 2.74587C61.121 0.98772 58.7364 0 56.25 0C53.7636 0 51.379 0.98772 49.6209 2.74587C47.8627 4.50403 46.875 6.8886 46.875 9.375V18.75H18.75C13.7772 18.75 9.00805 20.7254 5.49175 24.2417C1.97544 27.7581 0 32.5272 0 37.5V225C0 229.973 1.97544 234.742 5.49175 238.258C9.00805 241.775 13.7772 243.75 18.75 243.75H206.25C211.223 243.75 215.992 241.775 219.508 238.258C223.025 234.742 225 229.973 225 225V37.5C225 32.5272 223.025 27.7581 219.508 24.2417C215.992 20.7254 211.223 18.75 206.25 18.75ZM46.875 37.5V46.875C46.875 49.3614 47.8627 51.746 49.6209 53.5041C51.379 55.2623 53.7636 56.25 56.25 56.25C58.7364 56.25 61.121 55.2623 62.8791 53.5041C64.6373 51.746 65.625 49.3614 65.625 46.875V37.5H159.375V46.875C159.375 49.3614 160.363 51.746 162.121 53.5041C163.879 55.2623 166.264 56.25 168.75 56.25C171.236 56.25 173.621 55.2623 175.379 53.5041C177.137 51.746 178.125 49.3614 178.125 46.875V37.5H206.25V75H18.75V37.5H46.875Z" fill={appTheme.accentColor}/>
                        <text x="112" y="168" textAnchor="middle" dominantBaseline="middle" fill="#ffffff" fontSize="90" fontWeight="800" fontFamily="system-ui, -apple-system, sans-serif">
                          {mondayDate}
                        </text>
                      </svg>
                    );
                  })()}
                </button>
              )}
            </div>

            <button
              onClick={() => {
                const newOffset = planCalendarWeekOffset + 1;
                setPlanCalendarWeekOffset(newOffset);
                const newWeekDays = getPlanCalendarDays(newOffset);
                const currentDayIndex = weekDays.findIndex(d => getDateKey(d) === activeDateKey);
                const targetIndex = currentDayIndex >= 0 ? currentDayIndex : 0;
                setSelectedPlanDay(getDateKey(newWeekDays[targetIndex]));
              }}
              style={{ width: "32px", height: "32px", borderRadius: "999px", border: appTheme.pillBorder, background: appTheme.pillBackground, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
            >
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke={appTheme.primaryText} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          </div>

          {/* Day strip */}
          <div
            ref={dayStripRef}
            className="hide-scrollbar"
            style={{
              display: "flex", gap: "8px", overflowX: "auto",
              paddingBottom: "4px", marginBottom: "20px"
            }}
          >
            {weekDays.map((date) => {
              const dateKey = getDateKey(date);
              const isToday = dateKey === todayDateKey;
              const isSelected = dateKey === activeDateKey;
              const dayName = date.toLocaleDateString("en-GB", { weekday: "short" });
              const dayNum = date.getDate();

              return (
                <div
                  key={dateKey}
                  data-selected={isSelected}
                  onClick={() => setSelectedPlanDay(dateKey)}
                  style={{
  flexShrink: 0, display: "flex", flexDirection: "column",
  alignItems: "center", gap: "4px",
  padding: "8px 10px", borderRadius: "12px", cursor: "pointer",
  background: isToday && isSelected ? appTheme.accentColor : isSelected ? appTheme.accentColor : isToday ? appTheme.accentLight : appTheme.softBackground,
  border: isToday && isSelected ? appTheme.accentBorder : isSelected ? appTheme.accentBorder : isToday ? appTheme.accentBorder : "1px solid transparent",
  transition: "all 0.18s ease",
  minWidth: "52px",
  position: "relative"
}}
                >
                {isToday && (
    <div style={{
      position: "absolute",
      top: "5px",
      right: "5px",
      width: "6px",
      height: "6px",
      borderRadius: "999px",
      background: isSelected ? "#ffffff" : appTheme.accentColor
    }} />
  )}
  <div style={{
    fontSize: "10px", fontWeight: "700",
    color: isToday && isSelected ? "#ffffff" : isSelected ? "#ffffff" : isToday ? appTheme.accentColor : appTheme.secondaryText,
    textTransform: "uppercase", letterSpacing: "0.04em"
  }}>
    {dayName}
  </div>
  <div style={{
    fontSize: "16px", fontWeight: "800",
    color: isToday && isSelected ? "#ffffff" : isSelected ? "#ffffff" : isToday ? appTheme.accentColor : appTheme.primaryText,
    lineHeight: 1
  }}>
    {dayNum}
  </div>
</div>
              );
            })}
          </div>

          {/* Meal slots */}
          <div style={{ marginBottom: "24px" }}>
            {isLoading ? (
              ["breakfast", "lunch", "dinner"].map((mealType, i) => (
                <div key={mealType} style={{ display: "flex", gap: "2px" }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "36px", flexShrink: 0 }}>
                    <Skel w="36px" h="36px" r="999px" />
                    {i < 2 && <div style={{ width: "1.5px", flex: 1, minHeight: "12px", background: "rgba(0,0,0,0.1)", marginTop: "4px" }} />}
                  </div>
                  <div style={{ flex: 1, minWidth: 0, paddingBottom: "20px" }}>
                    <div style={{ height: "36px", display: "flex", alignItems: "center", marginBottom: "10px", paddingLeft: "8px" }}>
                      <Skel w="72px" h="13px" r="8px" />
                    </div>
                    <Skel h="64px" r="14px" />
                  </div>
                </div>
              ))
            ) : ["breakfast", "lunch", "dinner"].map((mealType) => {
              const meal = dayPlan[mealType];
              const mealKey = `${activeDateKey}-${mealType}`;
              const isCompleted = completedMeals[mealKey] || false;
              const accent = mealAccents[mealType];
              const menuKey = `${activeDateKey}-${mealType}`;

              return (
                <div key={mealType} style={{ display: "flex", gap: "2px" }}>
                  {/* Left col: icon circle + connector line */}
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "36px", flexShrink: 0 }}>
                    <div style={{
                      width: "36px", height: "36px", borderRadius: "999px",
                      background: accent.iconBg,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: accent.color, flexShrink: 0
                    }}>
                      {mealIcons[mealType]}
                    </div>
                    <div style={{ width: "1.5px", flex: 1, minHeight: "12px", background: "rgba(0,0,0,0.1)", marginTop: "4px" }} />
                  </div>

                  {/* Right col: label + content */}
                  <div style={{ flex: 1, minWidth: 0, paddingBottom: "20px" }}>
                    <div style={{ height: "36px", display: "flex", alignItems: "center", marginBottom: "10px", paddingLeft: "8px" }}>
                      <div style={{ fontSize: "14px", fontWeight: "700", color: appTheme.primaryText }}>
                        {mealType.charAt(0).toUpperCase() + mealType.slice(1)}
                      </div>
                    </div>

                  {meal ? (
                    <div
                      onClick={() => openRecipeDetails(meal, true, { dateKey: activeDateKey, mealType })}
                      style={{
                        padding: "8px 10px", borderRadius: "14px",
                        background: isCompleted ? "rgba(34,197,94,0.06)" : appTheme.cardBackground,
                        border: appTheme.cardBorder,
                        transition: "all 0.18s ease",
                        cursor: "pointer",
                        opacity: isCompleted ? 0.55 : 1
                      }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {/* Thumbnail */}
                        <div style={{
                          width: "46px", height: "46px", borderRadius: "10px",
                          flexShrink: 0, overflow: "hidden",
                          background: accent.bg,
                          border: `1px solid ${accent.border}`,
                          position: "relative"
                        }}>
                          {meal.image && (
                            <img
                              src={meal.image}
                              alt={meal.name}
                              loading="eager"
                              style={{
                                width: "100%", height: "100%",
                                objectFit: "cover", objectPosition: "center",
                                position: "absolute", inset: 0
                              }}
                            />
                          )}
                        </div>

                        {/* Name + meta */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ marginBottom: "3px" }}>
                            <div style={{
                              fontSize: "15px", fontWeight: "500",
                              color: appTheme.primaryText, lineHeight: 1.2,
                              fontFamily: appTheme.fontBody
                            }}>
                              {meal.name}
                            </div>
                          </div>
                          {(meal.time || meal.calories) && (
                            <div style={{ fontSize: "13px", color: appTheme.secondaryText }}>
                              {meal.time ? `${meal.time} min` : ""}
                              {meal.time && meal.calories ? " · " : ""}
                              {meal.calories ? `${meal.calories} kcal` : ""}
                            </div>
                          )}
                        </div>

                        {/* Tick + heart + three-dot */}
                        <div
                          onClick={(e) => e.stopPropagation()}
                          style={{ display: "flex", alignItems: "center", gap: "0px", flexShrink: 0 }}>
                          <button
                            onClick={(e) => { e.stopPropagation(); completeMeal(activeDateKey, mealType); }}
                            style={{
                              width: "28px", height: "28px", borderRadius: "999px",
                              border: "none", background: "transparent",
                              cursor: "pointer", padding: 0,
                              display: "flex", alignItems: "center", justifyContent: "center",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {isCompleted ? (
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="9" fill="rgba(34,197,94,0.85)"/>
                                <path d="M5.5 10l3 3 6-6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            ) : (
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="9" stroke={appTheme.mutedText} strokeWidth="1.6" fill="none"/>
                              </svg>
                            )}
                          </button>
                          <div style={{ position: "relative" }}>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setMealMenuOpen(prev => prev === menuKey ? null : menuKey);
                              }}
                              style={{
                                width: "28px", height: "28px", borderRadius: "999px",
                                border: "none", background: "transparent",
                                color: appTheme.secondaryText, fontSize: "22px",
                                cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                                letterSpacing: "0.05em"
                              }}
                            >⋮</button>
                            {mealMenuOpen === menuKey && (
                              <>
                                <div onClick={(e) => { e.stopPropagation(); setMealMenuOpen(null); }} style={{ position: "fixed", inset: 0, zIndex: 199 }} />
                                <div style={{
                                  position: "absolute", top: "38px", right: "0", zIndex: 200,
                                  width: "180px", borderRadius: "14px",
                                  background: appTheme.accentColor,
                                  boxShadow: "0 8px 24px rgba(15,23,42,0.18)",
                                  overflow: "hidden"
                                }}>
                                  <button onClick={() => { openManualEntryModal(activeDateKey, "ate-different", mealType); setMealMenuOpen(null); }} style={{
                                    width: "100%", padding: "12px 14px", border: "none",
                                    background: "transparent", color: "#ffffff",
                                    fontSize: "13px", fontWeight: "600", textAlign: "left", cursor: "pointer"
                                  }}>
                                    Ate something else
                                  </button>
                                  <div style={{ height: "1px", background: "rgba(255,255,255,0.18)", margin: "0 14px" }} />
                                  <button onClick={() => { openMealSlotSheet(activeDateKey, mealType); setMealMenuOpen(null); }} style={{
                                    width: "100%", padding: "12px 14px", border: "none",
                                    background: "transparent", color: "#ffffff",
                                    fontSize: "13px", fontWeight: "600", textAlign: "left", cursor: "pointer"
                                  }}>
                                    Swap meal
                                  </button>
                                  <div style={{ height: "1px", background: "rgba(255,255,255,0.18)", margin: "0 14px" }} />
                                  <button onClick={() => { removeFromPlan(activeDateKey, mealType); setMealMenuOpen(null); }} style={{
                                    width: "100%", padding: "12px 14px", border: "none",
                                    background: "transparent", color: "rgba(255,180,180,1)",
                                    fontSize: "13px", fontWeight: "600", textAlign: "left", cursor: "pointer"
                                  }}>
                                    Remove
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      onClick={() => (openMealChoice || openMealSlotSheet)(activeDateKey, mealType)}
                      style={{
                        padding: "14px 16px", borderRadius: "16px",
                        border: `1.5px dashed ${accent.color}55`,
                        background: "transparent",
                        cursor: "pointer", display: "flex", alignItems: "center",
                        justifyContent: "center", gap: "8px", transition: "all 0.18s ease"
                      }}
                    >
                      <span style={{ fontSize: "16px", color: appTheme.secondaryText, fontWeight: "300" }}>+</span>
                      <div style={{ fontSize: "14px", fontWeight: "500", color: appTheme.secondaryText }}>
                        Add {mealType}
                      </div>
                    </div>
                  )}
                  </div>{/* end right col */}
                </div>
              );
            })}

            {/* Snacks */}

            <div style={{ display: "flex", gap: "2px" }}>
              {/* Left col: icon only (no line after last item) */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "36px", flexShrink: 0 }}>
                <div style={{
                  width: "36px", height: "36px", borderRadius: "999px",
                  background: mealAccents.snacks.iconBg,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: mealAccents.snacks.color, flexShrink: 0
                }}>
                  {mealIcons.snacks}
                </div>
              </div>
              {/* Right col */}
              <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ height: "36px", display: "flex", alignItems: "center", marginBottom: "10px", paddingLeft: "8px" }}>
                <div style={{ fontSize: "14px", fontWeight: "700", color: appTheme.primaryText }}>
                  Snacks
                </div>
              </div>

              {(dayPlan.snacks || []).map((snack) => (
                <div key={snack.id} style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  gap: "10px", padding: "10px 14px", borderRadius: "14px",
                  marginBottom: "6px", background: appTheme.cardBackground,
                  border: appTheme.cardBorder
                }}>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <div style={{ fontSize: "14px", fontWeight: "600", color: appTheme.primaryText, lineHeight: 1.2 }}>
                      {snack.name}
                    </div>
                    <div style={{ fontSize: "12px", color: appTheme.secondaryText, marginTop: "2px" }}>
                      {snack.calories} kcal{snack.protein ? ` • ${snack.protein}g P` : ""}
                    </div>
                  </div>
                  <button
                    onClick={() => removeSnack(activeDateKey, snack.id)}
                    style={{
                      padding: "4px 10px", borderRadius: "999px",
                      border: appTheme.pillBorder, background: "transparent",
                      color: appTheme.secondaryText, fontSize: "11px",
                      fontWeight: "600", cursor: "pointer", flexShrink: 0
                    }}
                  >Remove</button>
                </div>
              ))}

              <div
                onClick={() => openManualEntryModal(activeDateKey, "plan")}
                style={{
                  padding: "14px 16px", borderRadius: "14px",
                  border: `1.5px dashed ${mealAccents.snacks.color}55`,
                  background: "transparent",
                  cursor: "pointer", display: "flex", alignItems: "center",
                  justifyContent: "center", gap: "8px", transition: "all 0.18s ease"
                }}
              >
                <span style={{ fontSize: "16px", color: appTheme.secondaryText, fontWeight: "300" }}>+</span>
                <div style={{ fontSize: "14px", fontWeight: "500", color: appTheme.secondaryText }}>
                  {(dayPlan.snacks || []).length > 0 ? "Add another snack" : "Add snack"}
                </div>
              </div>
              </div>{/* end right col */}
            </div>{/* end snacks flex row */}
          </div>{/* end meals container */}

          {/* Planned nutrition summary */}
          {(() => {
            const planMeals = ["breakfast", "lunch", "dinner"]
              .map(mt => dayPlan[mt])
              .filter(Boolean);
            const planSnacks = dayPlan.snacks || [];
            if (planMeals.length === 0 && planSnacks.length === 0) return null;

            const totals = planMeals.reduce((acc, meal) => ({
              calories: acc.calories + (meal.calories || 0),
              protein:  acc.protein  + (meal.macros?.protein || 0),
              carbs:    acc.carbs    + (meal.macros?.carbs   || 0),
              fats:     acc.fats     + (meal.macros?.fats    || 0),
            }), { calories: 0, protein: 0, carbs: 0, fats: 0 });
            planSnacks.forEach(s => {
              totals.calories += s.calories || 0;
              totals.protein  += s.protein  || 0;
              totals.carbs    += s.carbs    || 0;
              totals.fats     += s.fats     || 0;
            });

            const totalGrams = totals.protein + totals.carbs + totals.fats;
            const hasGrams = totalGrams > 0;

            return (
              <div style={{ marginTop: "16px", padding: "14px 16px 16px", borderRadius: "20px", background: appTheme.cardBackground, border: appTheme.cardBorder }}>
                <div style={{ fontSize: "13px", fontWeight: "700", color: appTheme.mutedText, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "10px", fontFamily: appTheme.fontBody }}>
                  Planned nutrition
                </div>
                <div style={{ fontSize: "24px", fontWeight: "700", color: appTheme.primaryText, fontFamily: appTheme.fontHeading, lineHeight: 1, marginBottom: "10px" }}>
                  {totals.calories > 0 ? totals.calories.toLocaleString() : "0"}
                  <span style={{ fontSize: "13px", fontWeight: "500", color: appTheme.secondaryText, marginLeft: "5px" }}>kcal</span>
                </div>
                <div style={{ height: "8px", borderRadius: "999px", background: appTheme.softBackground, overflow: "hidden", marginBottom: "7px" }}>
                  {hasGrams && (
                    <div style={{ display: "flex", height: "100%", borderRadius: "999px", overflow: "hidden" }}>
                      <div style={{ width: `${(totals.protein / totalGrams) * 100}%`, background: "#C0392B" }} />
                      <div style={{ width: `${(totals.carbs   / totalGrams) * 100}%`, background: "#f59e0b" }} />
                      <div style={{ width: `${(totals.fats    / totalGrams) * 100}%`, background: "#5B8DB8" }} />
                    </div>
                  )}
                </div>
                {hasGrams ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", fontFamily: appTheme.fontBody }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "12px", color: "#C0392B" }}>
                      <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#C0392B", flexShrink: 0, display: "inline-block" }} />
                      Protein {totals.protein}g
                    </span>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "12px", color: "#f59e0b" }}>
                      <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#f59e0b", flexShrink: 0, display: "inline-block" }} />
                      Carbs {totals.carbs}g
                    </span>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", fontSize: "12px", color: "#5B8DB8" }}>
                      <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#5B8DB8", flexShrink: 0, display: "inline-block" }} />
                      Fats {totals.fats}g
                    </span>
                  </div>
                ) : (
                  <div style={{ fontSize: "12px", color: appTheme.mutedText, fontFamily: appTheme.fontBody }}>
                    No nutrition data for planned meals
                  </div>
                )}
              </div>
            );
          })()}

          {/* Daily note */}
          <div style={{ height: "1px", background: appTheme.accentColor, opacity: 0.15, marginBottom: "16px", marginTop: "16px" }} />
          <DailyNoteCard
            appTheme={appTheme}
            isMobile={isMobile}
            dateKey={activeDateKey}
            note={dailyNotes[activeDateKey] || ""}
            onSave={setDailyNotes}
            onDelete={(key) => setDailyNotes(key, "")}
            planningMode="manual"
          />
        </>
      )}

      {/* ─── PROGRAMME MODE ──────────────────────────────────── */}
      {planningMode === "programme" && (
        <>
          {!selectedProgramme || isChangingProgramme ? (
            /* Programme list */
            <div>
              {isChangingProgramme && (
                <button
                  onClick={() => setIsChangingProgramme(false)}
                  style={{
                    display: "flex", alignItems: "center", gap: "6px",
                    padding: "8px 0", border: "none", background: "transparent",
                    color: appTheme.secondaryText, fontSize: "14px",
                    fontWeight: "600", cursor: "pointer", marginBottom: "12px"
                  }}
                >‹ Back to {selectedProgramme?.name}</button>
              )}

              <div style={{
                fontFamily: appTheme.fontHeading,
                fontSize: isMobile ? "22px" : "26px",
                fontWeight: "500", color: appTheme.primaryText,
                marginBottom: "4px"
              }}>
                Choose a programme
              </div>
              <div style={{ fontSize: "14px", color: appTheme.secondaryText, marginBottom: "20px", lineHeight: 1.5 }}>
                Pick a programme that fits your goals.
              </div>

              <div style={{ display: "grid", gap: "12px" }}>
                {filteredProgrammes
                  .filter(p => !isChangingProgramme || p.id !== selectedProgramme?.id)
                  .map((programme) => (
                  <div
                    key={programme.id}
                    onClick={() => openProgrammeDetails(programme)}
                    style={{
                      padding: isMobile ? "16px" : "18px", borderRadius: "20px",
                      background: appTheme.cardBackground, border: appTheme.cardBorder,
                      cursor: "pointer", display: "flex", alignItems: "center",
                      gap: "14px", transition: "all 0.18s ease"
                    }}
                  >
                    {/* Programme illustration placeholder */}
                    <div style={{
                      width: "52px", height: "52px", borderRadius: "14px",
                      background: appTheme.accentLight, border: appTheme.accentBorder,
                      flexShrink: 0, display: "flex", alignItems: "center",
                      justifyContent: "center", color: appTheme.accentColor
                    }}>
                      <svg viewBox="0 0 24 24" width="24" height="24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 11l3 3L22 4"/>
                        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                      </svg>
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontSize: "16px", fontWeight: "500", color: appTheme.primaryText,
                        marginBottom: "4px", fontFamily: appTheme.fontHeading
                      }}>
                        {programme.name}
                      </div>
                      <div style={{ fontSize: "13px", color: appTheme.secondaryText, marginBottom: "6px", lineHeight: 1.4 }}>
                        {programme.summary}
                      </div>
                      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                        {(programme.tags || [programme.duration, programme.focus]).map((tag, i) => (
                          <span key={tag} style={{
                            padding: "3px 8px", borderRadius: "999px",
                            background: i === 0 ? appTheme.accentLight : appTheme.pillBackground,
                            color: i === 0 ? appTheme.accentColor : appTheme.secondaryText,
                            fontSize: "11px", fontWeight: "700"
                          }}>{tag}</span>
                        ))}
                      </div>
                    </div>

                    <div style={{ fontSize: "20px", color: appTheme.mutedText, flexShrink: 0 }}>›</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            /* Active programme view */
            <>
              {/* Programme name */}
              <div style={{
                marginBottom: "16px",
                padding: "16px",
                borderRadius: "18px",
                background: appTheme.accentLight,
                border: appTheme.accentBorder,
                textAlign: "center"
              }}>
                <div style={{
                  fontFamily: appTheme.fontHeading,
                  fontSize: isMobile ? "18px" : "22px",
                  fontWeight: "500",
                  color: appTheme.primaryText,
                  lineHeight: 1.2
                }}>
                  {selectedProgramme?.name}
                </div>
                <div style={{
                  fontSize: "13px",
                  color: appTheme.secondaryText,
                  marginTop: "4px"
                }}>
                  {((filteredProgrammes?.find(p => p.id === selectedProgramme?.id) || selectedProgramme)?.tags || [selectedProgramme?.duration, selectedProgramme?.focus]).join(" • ")}
                </div>
              </div>

              {/* Week header row */}
              <button
                onClick={() => setShowWeekDropdown(prev => !prev)}
                style={{
                  width: "100%", display: "flex", alignItems: "center",
                  justifyContent: "space-between", gap: "8px",
                  padding: "0 2px", marginBottom: "14px",
                  border: "none", background: "transparent", cursor: "pointer"
                }}
              >
                <div style={{
                  fontFamily: appTheme.fontHeading,
                  fontSize: isMobile ? "24px" : "28px",
                  fontWeight: "500", color: appTheme.primaryText
                }}>
                  Week {currentProgrammeWeekIndex + 1}
                </div>
                <div style={{
                  color: appTheme.secondaryText, fontSize: "14px",
                  transform: showWeekDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease", flexShrink: 0
                }}>▾</div>
              </button>

              {/* Week dropdown — quick jump */}
              {showWeekDropdown && (
                <div className="hide-scrollbar" style={{
                  display: "flex", gap: "8px", overflowX: "auto",
                  paddingBottom: "4px", marginBottom: "14px"
                }}>
                  {Array.from({ length: getProgrammeWeekCount(selectedProgramme) }, (_, i) => (
                    <button
                      key={i}
                      onClick={() => { posthog.capture("programme_week_viewed", { week_number: i + 1 }); goToProgrammeWeek(i); }}
                      style={{
                        flexShrink: 0, padding: "7px 16px", borderRadius: "999px",
                        border: currentProgrammeWeekIndex === i ? appTheme.accentBorder : appTheme.pillBorder,
                        background: currentProgrammeWeekIndex === i ? appTheme.accentColor : appTheme.pillBackground,
                        color: currentProgrammeWeekIndex === i ? "#ffffff" : appTheme.secondaryText,
                        fontSize: "13px", fontWeight: currentProgrammeWeekIndex === i ? "700" : "500",
                        cursor: "pointer", transition: "all 0.18s ease"
                      }}
                    >
                      Week {i + 1}
                    </button>
                  ))}
                </div>
              )}

              {/* Progress bar */}
              {currentProgrammeWeek && (
                <div style={{ marginBottom: "16px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                    <div style={{ fontSize: "12px", color: appTheme.secondaryText }}>
                      {currentProgrammeProgress}% complete
                    </div>
                    <div style={{ fontSize: "12px", color: appTheme.secondaryText }}>
                      Week {currentProgrammeWeekIndex + 1} of {getProgrammeWeekCount(selectedProgramme)}
                    </div>
                  </div>
                  <div style={{ height: "8px", borderRadius: "999px", background: appTheme.softBackground, overflow: "hidden" }}>
                    <div style={{
                      height: "100%", width: `${currentProgrammeProgress}%`,
                      borderRadius: "999px", background: appTheme.accentColor,
                      transition: "width 0.4s ease"
                    }} />
                  </div>
                </div>
              )}

              {/* Day strip */}
              {currentProgrammeWeek && (
                <>
                  <div ref={programmeDayStripRef} className="hide-scrollbar" style={{
                    display: "flex", gap: "8px", overflowX: "auto",
                    paddingBottom: "4px", marginBottom: "20px"
                  }}>
                    {days.map((day) => {
                      const todayDayName = days[new Date().getDay() === 0 ? 6 : new Date().getDay() - 1];
                      const isToday = day === todayDayName;
                      const isSelected = day === (selectedProgrammeDay || todayDayName);

                      return (
                        <div
                          key={day}
                          data-active-prog={isSelected ? "true" : undefined}
                          onClick={() => setSelectedProgrammeDay(day)}
                          style={{
                            flexShrink: 0, display: "flex", flexDirection: "column",
                            alignItems: "center", gap: "4px",
                            padding: "10px 14px", borderRadius: "12px", cursor: "pointer",
                            background: isToday && isSelected ? appTheme.accentColor : isSelected ? appTheme.accentColor : isToday ? appTheme.accentLight : appTheme.softBackground,
border: isSelected && !isToday ? appTheme.accentBorder : isToday ? appTheme.accentBorder : "1px solid transparent",
                            transition: "all 0.18s ease",
                            minWidth: "52px",
                            position: "relative",
                          }}
                        >
                          {isToday && (
    <div style={{
      position: "absolute",
      top: "5px",
      right: "5px",
      width: "6px",
      height: "6px",
      borderRadius: "999px",
      background: isSelected ? "#ffffff" : appTheme.accentColor
    }} />
  )}
                          <div style={{
                            fontSize: "11px", fontWeight: "700",
                            color: isToday && isSelected ? "#ffffff" : isSelected && !isToday ? "#ffffff" : isToday ? appTheme.accentColor : appTheme.secondaryText,
                            textTransform: "uppercase", letterSpacing: "0.04em"
                          }}>
                            {day.substring(0, 3)}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Meal slots for selected day */}
                  {(() => {
                    const todayDayName = days[new Date().getDay() === 0 ? 6 : new Date().getDay() - 1];
                    const activeDay = selectedProgrammeDay || todayDayName;
                    const dayMeals = currentProgrammeWeek?.days?.[activeDay];

                    return (
                      <>
                      <div style={{ marginBottom: "24px" }}>
                        {["breakfast", "lunch", "dinner"].map((mealType) => {
                          const recipeName = dayMeals?.[mealType];
                          const mealKey = `week${currentProgrammeWeekIndex}-${activeDay}-${mealType}`;
                          const isCooked = completedMeals[mealKey] || false;
                          const accent = mealAccents[mealType];
                          const recipe = recipeName ? { name: recipeName } : null;
                          const menuKey = `prog-${activeDay}-${mealType}`;

                          return (
                            <div key={mealType} style={{ display: "flex", gap: "2px" }}>
                              {/* Left col: icon + connector line */}
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "36px", flexShrink: 0 }}>
                                <div style={{
                                  width: "36px", height: "36px", borderRadius: "999px",
                                  background: accent.iconBg,
                                  display: "flex", alignItems: "center", justifyContent: "center",
                                  color: accent.color, flexShrink: 0
                                }}>
                                  {mealIcons[mealType]}
                                </div>
                                <div style={{ width: "1.5px", flex: 1, minHeight: "12px", background: "rgba(0,0,0,0.1)", marginTop: "4px" }} />
                              </div>

                              {/* Right col: label + content */}
                              <div style={{ flex: 1, minWidth: 0, paddingBottom: "20px" }}>
                                <div style={{ height: "36px", display: "flex", alignItems: "center", marginBottom: "10px", paddingLeft: "8px" }}>
                                  <div style={{ fontSize: "14px", fontWeight: "700", color: appTheme.primaryText }}>
                                    {mealType.charAt(0).toUpperCase() + mealType.slice(1)}
                                  </div>
                                </div>

                              {/* Meal card */}
                              <div
                                onClick={() => {
                                  if (!recipeName) return;
                                  const fullRecipe = getRecipeByName(recipeName) || { name: recipeName };
                                  openRecipeDetails(fullRecipe, true, {
                                    weekIndex: currentProgrammeWeekIndex, day: activeDay, mealType, isProgramme: true
                                  });
                                }}
                                style={{
                                  padding: "8px 10px", borderRadius: "14px",
                                  background: isCooked ? "rgba(34,197,94,0.06)" : appTheme.cardBackground,
                                  border: appTheme.cardBorder,
                                  transition: "all 0.18s ease",
                                  cursor: recipe ? "pointer" : "default",
                                  opacity: isCooked ? 0.55 : 1
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                  {/* Thumbnail */}
                                  {(() => {
                                    const fullRecipe = getRecipeByName(recipeName);
                                    return (
                                      <div style={{
                                        width: "46px", height: "46px", borderRadius: "10px",
                                        flexShrink: 0, overflow: "hidden",
                                        background: accent.bg,
                                        border: `1px solid ${accent.border}`,
                                        position: "relative"
                                      }}>
                                        {fullRecipe?.image && (
                                          <img
                                            src={fullRecipe.image}
                                            alt={recipeName}
                                            loading="eager"
                                            style={{
                                              width: "100%", height: "100%",
                                              objectFit: "cover", objectPosition: "center",
                                              position: "absolute", inset: 0
                                            }}
                                          />
                                        )}
                                      </div>
                                    );
                                  })()}

                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ marginBottom: "3px" }}>
                                      <div style={{
                                        fontSize: "15px", fontWeight: "500",
                                        color: appTheme.primaryText, lineHeight: 1.2,
                                        fontFamily: appTheme.fontBody
                                      }}>
                                        {recipeName || "Not planned"}
                                      </div>
                                    </div>
                                    {(() => {
                                      const fullRecipe = getRecipeByName(recipeName);
                                      if (!fullRecipe?.time && !fullRecipe?.calories) return null;
                                      return (
                                        <div style={{ fontSize: "13px", color: appTheme.secondaryText }}>
                                          {fullRecipe.time ? `${fullRecipe.time} min` : ""}
                                          {fullRecipe.time && fullRecipe.calories ? " · " : ""}
                                          {fullRecipe.calories ? `${fullRecipe.calories} kcal` : ""}
                                        </div>
                                      );
                                    })()}
                                  </div>

                                  {/* Actions */}
                                  <div
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ display: "flex", alignItems: "center", gap: "0px", flexShrink: 0 }}
                                  >
                                    <button
                                      onClick={(e) => { e.stopPropagation(); completeMeal(`week${currentProgrammeWeekIndex}-${activeDay}`, mealType); }}
                                      style={{
                                        width: "28px", height: "28px", borderRadius: "999px",
                                        border: "none", background: "transparent",
                                        cursor: "pointer", padding: 0,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        transition: "all 0.18s ease",
                                      }}
                                    >
                                      {isCooked ? (
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                          <circle cx="10" cy="10" r="9" fill="rgba(34,197,94,0.85)"/>
                                          <path d="M5.5 10l3 3 6-6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                      ) : (
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                          <circle cx="10" cy="10" r="9" stroke={appTheme.mutedText} strokeWidth="1.6" fill="none"/>
                                        </svg>
                                      )}
                                    </button>
                                    <div style={{ position: "relative" }}>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setMealMenuOpen(prev => prev === menuKey ? null : menuKey);
                                        }}
                                        style={{
                                          width: "28px", height: "28px", borderRadius: "999px",
                                          border: "none", background: "transparent",
                                          color: appTheme.secondaryText, fontSize: "22px",
                                          cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                                          letterSpacing: "0.05em"
                                        }}
                                      >⋮</button>
                                      {mealMenuOpen === menuKey && (
                                        <>
                                          <div onClick={(e) => { e.stopPropagation(); setMealMenuOpen(null); }} style={{ position: "fixed", inset: 0, zIndex: 199 }} />
                                          <div style={{
                                            position: "absolute", top: "34px", right: "0", zIndex: 200,
                                            width: "160px", borderRadius: "14px",
                                            background: appTheme.accentColor,
                                            boxShadow: "0 8px 24px rgba(15,23,42,0.18)",
                                            overflow: "hidden"
                                          }}>
                                            {(() => {
                                              const dayIdx = days.indexOf(activeDay);
                                              const progDate = dayIdx >= 0 ? weekDays[dayIdx] : null;
                                              const progDateKey = progDate ? getDateKey(progDate) : null;
                                              return progDateKey ? (
                                                <>
                                                  <button onClick={() => { openManualEntryModal(progDateKey, "ate-different", mealType); setMealMenuOpen(null); }} style={{
                                                    width: "100%", padding: "12px 14px", border: "none",
                                                    background: "transparent", color: "#ffffff",
                                                    fontSize: "13px", fontWeight: "600", textAlign: "left", cursor: "pointer"
                                                  }}>
                                                    Ate something else
                                                  </button>
                                                  <div style={{ height: "1px", background: "rgba(255,255,255,0.18)", margin: "0 14px" }} />
                                                </>
                                              ) : null;
                                            })()}
                                            <button onClick={() => { startProgrammeMealSwap(currentProgrammeWeekIndex, activeDay, mealType); setMealMenuOpen(null); }} style={{
                                              width: "100%", padding: "12px 14px", border: "none",
                                              background: "transparent", color: "#ffffff",
                                              fontSize: "13px", fontWeight: "600", textAlign: "left", cursor: "pointer"
                                            }}>
                                              Swap meal
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              </div>{/* end right col */}
                            </div>
                          );
                        })}
                      </div>

                      {/* Daily note — use real calendar date for this programme day */}
                      {(() => {
                        const dayIndex = days.indexOf(activeDay);
                        const programmeDate = dayIndex >= 0 ? weekDays[dayIndex] : null;
                        const programmeDateKey = programmeDate ? getDateKey(programmeDate) : null;
                        if (!programmeDateKey) return null;
                        return (
                          <>
                            <div style={{ height: "1px", background: appTheme.accentColor, opacity: 0.15, marginBottom: "16px", marginTop: "16px" }} />
                            <DailyNoteCard
                              appTheme={appTheme}
                              isMobile={isMobile}
                              dateKey={programmeDateKey}
                              note={dailyNotes[programmeDateKey] || ""}
                              onSave={setDailyNotes}
                              onDelete={(key) => setDailyNotes(key, "")}
                              planningMode="programme"
                            />
                          </>
                        );
                      })()}
                       </>
                    );
                  })()}
                </>
              )}
            </>
          )}
        </>
      )}

      {/* ─── CONFIRMATION MODALS ────────────────────────────── */}

      {showClearPlanConfirm && (
        <div onClick={() => setShowClearPlanConfirm(false)} style={{
          position: "fixed", inset: 0, background: "rgba(15,23,42,0.18)",
          backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "24px", zIndex: 99999
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            width: "100%", maxWidth: "520px", borderRadius: "28px",
            background: appTheme.elevatedBackground, border: appTheme.cardBorder,
            boxShadow: "0 24px 80px rgba(15,23,42,0.22)", padding: isMobile ? "24px" : "32px"
          }}>
            <div style={{ fontSize: isMobile ? "24px" : "28px", fontWeight: "500", color: appTheme.primaryText, marginBottom: "24px", fontFamily: appTheme.fontHeading }}>
              Clear this week?
            </div>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <button onClick={() => setShowClearPlanConfirm(false)}
                style={secondaryButtonStyle(appTheme, hoveredButton, "cancel-clear-plan")}>Cancel</button>
              <button onClick={() => { clearEntirePlan(); setShowClearPlanConfirm(false); }}
                style={secondaryButtonStyle(appTheme, hoveredButton, "confirm-clear-plan")}>Clear week</button>
            </div>
          </div>
        </div>
      )}

      {showRemoveAllWeeksConfirm && (
        <div onClick={() => setShowRemoveAllWeeksConfirm(false)} style={{
          position: "fixed", inset: 0, background: "rgba(15,23,42,0.18)",
          backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "24px", zIndex: 99999
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            width: "100%", maxWidth: "520px", borderRadius: "28px",
            background: appTheme.elevatedBackground, border: appTheme.cardBorder,
            boxShadow: "0 24px 80px rgba(15,23,42,0.22)", padding: isMobile ? "24px" : "32px"
          }}>
            <div style={{ fontSize: isMobile ? "24px" : "28px", fontWeight: "500", color: appTheme.primaryText, marginBottom: "24px", fontFamily: appTheme.fontHeading }}>
              Remove all weeks?
            </div>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <button onClick={() => setShowRemoveAllWeeksConfirm(false)}
                style={secondaryButtonStyle(appTheme, hoveredButton, "cancel-remove-all")}>Cancel</button>
              <button onClick={() => { removeAllWeeks(); setShowRemoveAllWeeksConfirm(false); }}
                style={secondaryButtonStyle(appTheme, hoveredButton, "confirm-remove-all")}>Remove all</button>
            </div>
          </div>
        </div>
      )}

      {showRestartConfirm && (
        <div onClick={() => setShowRestartConfirm(false)} style={{
          position: "fixed", inset: 0, background: "rgba(15,23,42,0.18)",
          backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "24px", zIndex: 99999
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            width: "100%", maxWidth: "520px", borderRadius: "28px",
            background: appTheme.elevatedBackground, border: appTheme.cardBorder,
            boxShadow: "0 24px 80px rgba(15,23,42,0.22)", padding: isMobile ? "24px" : "32px"
          }}>
            <div style={{ fontSize: isMobile ? "24px" : "28px", fontWeight: "500", color: appTheme.primaryText, marginBottom: "12px", fontFamily: appTheme.fontHeading }}>
              Restart Programme?
            </div>
            <div style={{ fontSize: "14px", color: appTheme.secondaryText, lineHeight: 1.6, marginBottom: "24px" }}>
              This will reset your progress back to the beginning. Your meal swaps will be kept.
            </div>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <button onClick={() => setShowRestartConfirm(false)}
                style={secondaryButtonStyle(appTheme, hoveredButton, "cancel-restart")}>Cancel</button>
              <button onClick={() => { restartProgramme(); setShowRestartConfirm(false); }}
                style={{ ...secondaryButtonStyle(appTheme, hoveredButton, "confirm-restart"), border: appTheme.actionBorder, background: appTheme.actionLight, color: appTheme.actionColor }}>
                Restart
              </button>
            </div>
          </div>
        </div>
      )}

      {showQuitConfirm && (
        <div onClick={() => setShowQuitConfirm(false)} style={{
          position: "fixed", inset: 0, background: "rgba(15,23,42,0.18)",
          backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "24px", zIndex: 99999
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            width: "100%", maxWidth: "520px", borderRadius: "28px",
            background: appTheme.elevatedBackground, border: appTheme.cardBorder,
            boxShadow: "0 24px 80px rgba(15,23,42,0.22)", padding: isMobile ? "24px" : "32px"
          }}>
            <div style={{ fontSize: isMobile ? "24px" : "28px", fontWeight: "500", color: appTheme.primaryText, marginBottom: "12px", fontFamily: appTheme.fontHeading }}>
              Leave Programme?
            </div>
            <div style={{ fontSize: "14px", color: appTheme.secondaryText, lineHeight: 1.6, marginBottom: "24px" }}>
              You'll be switched back to Manual mode. You can always start this programme again later.
            </div>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <button onClick={() => setShowQuitConfirm(false)}
                style={secondaryButtonStyle(appTheme, hoveredButton, "cancel-quit")}>Cancel</button>
              <button onClick={() => { quitProgramme(); setShowQuitConfirm(false); }}
                style={{ ...secondaryButtonStyle(appTheme, hoveredButton, "confirm-quit"), border: appTheme.actionBorder, background: appTheme.actionLight, color: appTheme.actionColor }}>
                Leave
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ height: isMobile ? "100px" : "40px" }} />

      {/* PROGRAMME GATE — remove this entire block to re-enable programme mode */}
      {showProgrammeSheet && (
        <>
          <div
            onClick={() => setShowProgrammeSheet(false)}
            style={{
              position: "fixed", inset: 0, zIndex: 1800,
              background: "rgba(26,26,26,0.45)",
              backdropFilter: "blur(4px)", WebkitBackdropFilter: "blur(4px)",
            }}
          />
          <div style={{
            position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 1801,
            background: appTheme.cardBackground,
            borderRadius: "24px 24px 0 0",
            padding: "14px 24px 52px",
            animation: "settingsSheetIn 0.28s cubic-bezier(0.22, 1, 0.36, 1)",
          }}>
            {/* Drag handle */}
            <div
              onClick={() => setShowProgrammeSheet(false)}
              style={{
                width: "36px", height: "4px", borderRadius: "2px",
                background: "rgba(0,0,0,0.15)", margin: "0 auto 28px", cursor: "pointer",
              }}
            />
            {/* Star icon */}
            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <svg viewBox="0 0 256 256" width="36" height="36" fill={appTheme.accentColor}>
                <path d="M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.29a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86A16.4,16.4,0,0,0,16.8,97.26,16.18,16.18,0,0,0,21.73,115l45,38.83L52.26,212.68a16.25,16.25,0,0,0,6.35,17.94,16.55,16.55,0,0,0,18.9.6L128,199.19l50.49,32.03a16.54,16.54,0,0,0,18.9-.6,16.25,16.25,0,0,0,6.35-17.94L189.27,153.84,234.27,115A16.18,16.18,0,0,0,239.18,97.26Zm-15.34,5.47-45,38.83a8,8,0,0,0-2.6,8.08l14.41,52.29a.37.37,0,0,1-.14.48c-.15.09-.31.09-.5,0l-50.49-32.03a8,8,0,0,0-8.38,0L81.63,202.41c-.19.11-.35.11-.5,0a.37.37,0,0,1-.14-.48l14.41-52.29a8,8,0,0,0-2.6-8.08l-45-38.83a.38.38,0,0,1-.12-.5c.09-.22.25-.28.38-.29l59-4.76a8,8,0,0,0,6.77-5.18l22.77-55a.36.36,0,0,1,.7,0l22.77,55a8,8,0,0,0,6.77,5.18l59,4.76c.13,0,.29.07.38.29A.38.38,0,0,1,223.84,102.73Z"/>
              </svg>
            </div>
            {/* Heading */}
            <h2 style={{
              fontFamily: appTheme.fontHeading,
              fontSize: "22px", fontWeight: "600",
              color: appTheme.primaryText,
              textAlign: "center", margin: "0 0 10px",
            }}>
              Programmes — Coming Soon
            </h2>
            {/* Body */}
            <p style={{
              fontFamily: appTheme.fontBody,
              fontSize: "14px", color: appTheme.secondaryText,
              textAlign: "center", lineHeight: 1.6, margin: "0 0 28px",
            }}>
              Curated meal plans built around your goals. Full programmes are coming in the next update — stay tuned.
            </p>
            {/* CTA */}
            <button
              onClick={() => setShowProgrammeSheet(false)}
              style={{
                width: "100%", padding: "16px", borderRadius: "14px",
                border: "none", background: appTheme.accentColor,
                color: "#fff", fontFamily: appTheme.fontBody,
                fontWeight: "700", fontSize: "16px",
                cursor: "pointer", touchAction: "manipulation",
              }}
            >
              Got it
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default PlanTab;